<template>
  <div class="home_wrapper">
    <div class="module1">
      <div class="left_cont">
        <img :src="imgUrl+'sp_code.jpg'" width="126px" />
        <div class="img_tip">
          您也可以通过微信小程序<br>来享受这些服务
        </div>
      </div>

      <div class="right_cont">
        <div class="in_wrapper">
          <div class="cont">
            <div class="zxzjsb" @click="toNotice">
              <div class="icon_img">
                <img :src="imgUrl+'icon_zxzjsb.png'" width="78px"/>
              </div>
              <div class="txt_outer">
                <h2>专项资金申报</h2>
                <div>申请扶持资金，助力企业发展！</div>
              </div>
              <i class="cloudicon ci_arrow_right" ></i>
            </div>
            <div class="wysq" @click="toAppeal">
              <div class="icon_img">
                <img :src="imgUrl+'icon_wysq.png'" width="68px"/>
              </div>
              <div class="txt_outer">
                <h2>我有诉求</h2>
                <div class="p">随时向我们提出您的困难、需求、意见和建议！</div>
              </div>
              <i class="cloudicon ci_arrow_right"></i>
            </div>
          </div>
          <div class="cont">
            <div class="item" @click="toSurvey">
              <div class="left_img">
                <img :src="imgUrl+'icon_sjdc.png'"/>
              </div>
              <div>
                <h3>数据调查</h3>
                <div class="p">周期性填报统计，协助开发区管理</div>
              </div>
              <i class="cloudicon ci_arrow_right" ></i>
            </div>
            <div class="item" @click="toVisit">
              <div class="left_img">
                <img :src="imgUrl+'icon_qyzf.png'"/>
              </div>
              <div>
                <h3>企业走访</h3>
                <div class="p">做好企业日常联络、信息统计与专项跟进</div>
              </div>
              <i class="cloudicon ci_arrow_right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="module2">
      <div class="sb_item sb_item1">
        <div class="m_title">申报通知</div>
        <div class="m_tip">
          了解开发区最新服务动态搭上企业服务直通车
        </div>
        <div>
          <img :src="imgUrl+'icon_more.png'" height="22px" class="more" @click="toNotice" />
        </div>
      </div>
      <div class="sb_item" v-for="(item,index) in sbtzData" :key="index" @click="toNDetail(item)">
        <div class="img_outer">
          <img :src="imgUrl+item.icon"/>
        </div>
        <div style="color: #143367;font-weight: bold;font-size: 15px;">
          {{ item.post_title }}
        </div>
        <div class="item_btm">
          <span style="color:#999999;font-size: 12px;">{{ item.published_time }}</span>
          <img v-if="item.isnew===1" :src="imgUrl+item.new"/>
        </div>
      </div>
    </div>

    <div class="module3">
      <div class="sb_item1">
        <div class="m_title">惠企政策</div>
        <div class="m_tip">
          目前共有惠企政策{{totalPolicy}}条
        </div>
        <div>
          <img :src="imgUrl+'icon_more.png'" height="22px" class="more" @click="toPolicy" />
        </div>
      </div>
      <div class="table_outer hqzc">

        <el-table :data="tablelist" stripe @cell-click="toDetail" style="width: 100%">
          <el-table-column prop="post_title" label="政策名称" width="400"></el-table-column>
          <el-table-column prop="policy" label="政策类型" width="180"></el-table-column>
          <el-table-column prop="level" label="政策层级"></el-table-column>
          <el-table-column prop="published_time" label="发布时间"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="module4">
      <div class="sb_item1">
        <div class="m_title">企业橱窗</div>
        <div class="m_tip" style="width: 364px;">
          目前共有{{totalCorp}}家企业
        </div>
        <div>
          <img :src="imgUrl+'icon_more2.png'" height="22px" class="more" @click="toBshow" />
        </div>
      </div>
      <div class="carousel_outer" style="width: 100%;">
        <el-carousel :interval="4000" type="card" height="360px" :autoplay="false" arrow="always">
          <el-carousel-item v-for="(item,index) in bsData" :key="index" class="carousel_item">
            <div class="cont medium" @click="toBdetail(item.id)">
              <div class="img_wrapper">
                <img :src="item.logo"/>
              </div>
              <h3>
                {{ item.post_title }}
              </h3>
              <div class="p">
                {{ item.post_excerpt }}
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="module5">
      <div class="cont cont_left">
        <div>
          <div class="m_title">第三方服务</div>
          <div>
            <img @click="moreServe" :src="imgUrl+'icon_more.png'" height="22px"/>
          </div>
        </div>
        <div class="m_tip m_tip2">
          减少中间渠道，节省成本，直接和正规供应商一对一沟通
        </div>
      </div>

      <div class="cont cont_right">
        <div>
          <div class="m_title">为您推荐</div>
          <div class="m_tip m_tip2">
            相关网站链接
          </div>
        </div>
        <div class="select_outer">
          <el-select class="select_el" v-model="value" placeholder="请选择" @change="changeServe">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'

export default {
  name: 'homepage',
  data() {
    return {
      sbtzData: [],
      bsData: [],
      options: [
        {value: 'http://www.fengpu.com/', label: '上海市工业综合开发区官网'},
        {value: 'http://fxcy.67156715.com/', label: '奉贤区产业发展扶持政策申报服务平台'},
        {value: 'http://www.67156715.com/', label: '奉贤区企业信息服务互动平台'},
        {value: 'https://www.fengxian.gov.cn/', label: '奉贤区官网'},
        {value: 'http://www.shanghai.gov.cn/', label: '中国上海'}
      ],
      value: '',
      tablelist: [],
      totalPolicy:0,
      totalCorp:0,
      totalNts:0
    }
  },
  created() {
    this.$ajax.get(this.bUrl+'api/portal/lists/policy?page=1&pagesize=8')
      .then(function (res) {
        this.tablelist = res.data.data.list;
        this.totalPolicy=res.data.data.total;

      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

    this.$ajax.get(this.bUrl+'api/portal/lists/corp?page=1&pagesize=10')
      .then(function (res) {
        this.bsData = res.data.data.list;
        this.totalCorp=res.data.data.total;
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

    this.$ajax.get(this.bUrl+'api/portal/articles?page=1&pagesize=7')
      .then(function (res) {
        this.sbtzData = res.data.data.list;
        this.sbtzData.forEach(item=>{
          item.new="icon_new.png";
          if(item.view_type==="通知"){
            item.icon="icon_noti.png"
          }else if(item.view_type==="公告"){
            item.icon="icon_am.png"
          }else{
            item.icon="icon_line.png";
          }
        });
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

  },
  methods: {
    toNotice() {
      this.$router.push({path: '/notice'})
    },
    toAppeal(){
    	this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
      .then(function (res) {
    	  if(res.data.code!=200){
	        this.$message.error(res.data.msg);
	      }else{
	      	let roleId = JSON.parse(localStorage.getItem('gyzhqy_user_info')).role_id
					let userType = JSON.parse(localStorage.getItem('gyzhqy_user_info')).user_type
					if(userType==2){
						if(roleId.indexOf(3)<0){
							this.$message.error('抱歉！您没有访问权限');
							return
						}
					}
	      	this.$router.push({path:'/userappeal'})
	      }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });

		},
		toSurvey(){
			this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
      .then(function (res) {
    	  if(res.data.code!=200){
	        this.$message.error(res.data.msg);
	      }else{
	      	let roleId = JSON.parse(localStorage.getItem('gyzhqy_user_info')).role_id
					let userType = JSON.parse(localStorage.getItem('gyzhqy_user_info')).user_type
					if(userType==2){
						if(roleId.indexOf(1)<0){
							this.$message.error('抱歉！您没有访问权限');
							return
						}
					}
					if(res.data.data.jjyx!=1){
						this.$router.push({path:'/usersurvey2'})
						return
					}
	      	this.$router.push({path:'/usersurvey'})
	      }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
		},
		toVisit(){
			this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
      .then(function (res) {
    	  if(res.data.code!=200){
	        this.$message.error(res.data.msg);
	      }else{
	      	let roleId = JSON.parse(localStorage.getItem('gyzhqy_user_info')).role_id
					let userType = JSON.parse(localStorage.getItem('gyzhqy_user_info')).user_type
					if(userType==2){
						if(roleId.indexOf(4)<0){
							this.$message.error('抱歉！您没有访问权限');
							return
						}
					}
	      	this.$router.push({path:'/uservisit'})
	      }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
		},
    toDetail(row, column, event, cell) {
      this.$router.push({name: 'polidetail',query: {id: row.id}})
    },
    toNDetail(item) {
      this.$router.push({name: 'notidetail',query: {id:item.id,type:item.view_type}})
    },
    toBshow() {
      this.$router.push({name: 'bshow'})
    },
    toBdetail(id) {
      this.$router.push({name: 'bsdetail',query: {id,total:this.totalCorp}})
    },
    toPolicy(){
    	this.$router.push({name:'policy'})
    },
    changeServe(){
      window.open(this.value);
    },
    moreServe(){
      this.$message.info("暂无更多第三方服务");
    }
  }
}
</script>

<style scoped>
.home_wrapper {
  background: #fff url('/gyzhqyimgs/home_bg.png') no-repeat center -160px;
}

.module1 {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  padding-top: 200px;
  padding-bottom: 41px;
  justify-content: space-between;
}

.module1 .left_cont img {
  box-shadow: 6px 6px 6px rgba(255, 255, 255, .39);
  border-radius: 10px;
}

.module1 .left_cont .img_tip {
  color: #fff;
  /*font-weight: bold;*/
  font-size: 26px;
  line-height: 42px;
  margin-top: 16px;
}

.right_cont {
  width: 775px;
  height: 370px;
  box-sizing: border-box;
  padding: 24px;
  background: rgba(255, 255, 255, .4);
  position: relative;
  border-radius: 10px;
  box-shadow: 0 3px 26px rgb(0, 0, 0, .16);
}

.right_cont:after {
  content: '';
  position: absolute;
  width: 727px;
  height: 322px;
  top: 24px;
  left: 24px;
  background: rgba(255, 255, 255, .6);
  filter: blur(30px);
}

.right_cont .in_wrapper {
  position: absolute;
  width: 727px;
  height: 322px;
  z-index: 2;
}

.right_cont .in_wrapper .cont {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.right_cont .in_wrapper .cont .cloudicon {
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 26px;
  line-height: 34px;
  text-align: center;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
}

.zxzjsb {
  width: 442px;
  height: 180px;
  background: #399FFF;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.zxzjsb .cloudicon {
  color: #399FFF;
  background: #fff;
}

.wysq .cloudicon {
  color: #A0C760;
  background: #fff;
}

.wysq {
  width: 259px;
  height: 180px;
  background: #A0C760;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.zxzjsb .txt_outer, .wysq .txt_outer {
  padding-left: 24px;
  color: #fff;
}

.zxzjsb .txt_outer h2, .wysq .txt_outer h2 {
  margin-bottom: 8px;
}

.icon_img {
  padding-top: 10px;
  padding-right: 20px;
  font-size: 0;
  text-align: right;
}

.right_cont .in_wrapper .cont .item {
  width: 350px;
  height: 117px;
  box-sizing: border-box;
  position: relative;
  background: #EEF0F7;
  border-radius: 10px;
  margin-top: 25px;
  display: flex;
  align-items: center;
  padding: 20px;
  cursor: pointer;
}

.right_cont .in_wrapper .cont .item .left_img {
  margin-right: 20px;
}

.right_cont .in_wrapper .cont .item h3 {
  margin-bottom: 8px;
}

.right_cont .in_wrapper .cont .p {
  width: 186px;
  line-height: 24px;
}

.right_cont .in_wrapper .cont .item .cloudicon {
  background: #EA9557;
  color: #fff;
}

.module2 {
  width: 1180px;
  margin: 75px auto 0 auto;
  display: flex;
  flex-wrap: wrap;
  background: transparent url('/gyzhqyimgs/icon_sbtz.png') no-repeat 90px 0 !important;
}

.module2 .sb_item {
  width: 24%;
  margin-right: 1.3%;
  height: 190px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.3%;
  cursor: pointer;
}
.module2 .sb_item:nth-child(4n){
	margin-right: 0;
}
.sb_item .img_outer {
  height: auto;
}

.sb_item .item_btm {
  width: calc(100% - 40px);
  position: absolute;
  bottom: 20px;
}

.sb_item .item_btm img {
  margin-top: 5px;
  float: right;
}

.sb_item1 {
  background: transparent !important;
  border: 0 !important;
}

.m_title {
  color: #143367;
  font-size: 28px;
  margin-bottom: 16px;
}

.m_tip {
  width: 120px;
  color: #2574AD;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.m_tip2 {
  width: 182px;
}

.module3 {
  width: 1180px;
  margin: 75px auto 0 auto;
  display: flex;
  justify-content: space-between;
  padding-left: 28px;
}

.module3 .table_outer {
  width: 870px;
  border: 1px solid #E1EAFA;
  border-radius: 10px;
  background: #fff;
}


.module4 {
  width: 1180px;
  margin: 148px auto 0 auto;
  padding-left: 28px;
}

.el-carousel__item--card {
  width: 37% !important;
  margin: 0 6.5%;
}

.carousel_outer {
  margin-top: 32px;
}

.carousel_outer .carousel_item {
  background: transparent;
}

.carousel_item .img_wrapper {
  text-align: center;
}
.carousel_item .img_wrapper img{
  max-width: 150px;
  max-height: 100px;
}

.carousel_item h3 {
  color: #143367;
  font-size: 14px;
  text-align: center;
  margin: 10px 0 20px 0;
}

.carousel_item .p {
  font-size: 13px;
  color: #666;
	height: 103px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 6;
	text-overflow: ellipsis;
}

.carousel_item .cont {
  width: 276px;
  height: 330px;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #E1EAFA;
  box-shadow: 0 3px 6px rgba(0, 78, 214, .16);
}

.module5 {
  width: 1180px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 600px;
  left: 50%;
  margin-left: -590px;
}

.module5 .cont {
  height: 140px;
  background: #F0F5F8;
  border-radius: 10px;
  border: 1px solid #E1EAFA;
  padding: 28px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.module5 .cont_left {
  width: 448px;
}

.module5 .cont_right {
  width: 713px;
}

.select_outer {
  width: 350px;
  margin: auto auto;
}

.select_outer .select_el {
  width: 100%;
}
.more{
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/homepage.vue